import { callApiToServer } from "../callApi";

export async function deleteFaq(authToken, faqId, courseId) {
  console.log(faqId);
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authToken,
    };

    let body = JSON.stringify({
      faq_id: faqId,
      course_id: courseId,
    });

    let endUrl = "v1/auth/admin/delete-faq";

    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
